import Vue from 'vue';
import 'normalize.css';
import './plugins/antd';
import './plugins/mq';
import './scss/app.scss';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.filter(
  'capitalize',
  ([firstChar, ...complement]) => `${firstChar.toUpperCase()}${complement}`
);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
